import React, { useState } from 'react';
import { BulbIcon } from '@components/userDocuments/editDocument/editResume/tutorials/TutorialVideos/icons';
import styled from 'styled-components';
import TutorialModal from './tutorialModal';

interface TutorialButtonProps {
  tutorialLink: string;
  title: string;
  label: string;
}

export const TutorialButtonWrapper = styled.button`
  background-color: transparent;
  box-shadow: 0px 0px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 24px;
  width: 24px !important;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;
const TutorialButton: React.FC<TutorialButtonProps> = ({
  tutorialLink,
  title,
  label,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <>
        <TutorialButtonWrapper
          aria-label={label}
          onClick={handleOpenModal}
          className="py-0"
          title={title}
        >
          <BulbIcon />
        </TutorialButtonWrapper>
        {isModalOpen && (
          <TutorialModal
            onOpen={isModalOpen}
            onClose={handleCloseModal}
            videoUrl={tutorialLink}
          />
        )}
      </>
    </>
  );
};

export default TutorialButton;
